import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Stack/Stack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(marketing)/Fahid-Island/fahidbeachhouse/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(marketing)/Fahid-Island/PageWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/FahidWhatsAppIcon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HomeSpecification/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseArchitecture/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseDiscover/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseFooter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseRegisterBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseRegistration/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components-launch/FahidIsland/HouseSlider/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/FahidIsland/HouseWelcome/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonTransition/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Desktop"] */ "/app/src/components/Desktop/Desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mobile"] */ "/app/src/components/Mobile/Mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SplideSlider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisclaimerToggleProvider"] */ "/app/src/hooks/useDisclaimerToggle.tsx");
